import { boolean, enums, object } from "superstruct";

import { QR_CODE } from "../../QRCode/constants";

const RewardsStorefrontValuesPosSettingsSchema = object({
    codeType: enums([QR_CODE.barcode_1d, QR_CODE.barcode_2d]),
    isEnabled: boolean(),
});

export default RewardsStorefrontValuesPosSettingsSchema;
